/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';

import {
  loadHeader,
  loadStaticHeader,
} from 'app/gamma/src/modules/loaders/load-header';
import { State } from 'app/gamma/src/modules/types';
import { getMe } from 'app/gamma/src/selectors/members';
import { getMyId, isLoggedIn } from 'app/gamma/src/selectors/session';

import { MemberModel } from 'app/gamma/src/types/models';
import { Dispatch } from 'app/gamma/src/types';
import Header from './header';

import addSubscription from 'app/scripts/init/subscriber';
interface StateProps {
  readonly myId: string;
  readonly isLoggedIn: boolean;
  readonly me: MemberModel | undefined;
  readonly alwaysOpenBoardsMenu: boolean;
  readonly brandingColor: string | undefined;
}
interface DispatchProps {
  readonly loadHeaderData: (id: string) => void;
  readonly loadStaticHeaderData: (id: string) => void;
}
interface AllProps extends StateProps, DispatchProps {
  isStatic?: boolean;
  staticHeaderColor?: string;
}

class HeaderContainer extends React.Component<AllProps> {
  unsubscribeFromUpdates?: () => void;

  loader = (prevProps = { myId: '' }) => {
    const { loadHeaderData, loadStaticHeaderData, myId, isStatic } = this.props;
    if (myId && myId !== prevProps.myId) {
      if (isStatic) {
        loadStaticHeaderData(myId);
      } else {
        this.unsubscribe();
        this.unsubscribeFromUpdates = addSubscription({
          modelType: 'Member',
          idModel: myId,
          tags: ['messages', 'updates'],
        });

        loadHeaderData(myId);
      }
    }
  };

  constructor(props: AllProps) {
    super(props);
    this.loader();
  }

  componentDidUpdate(prevProps: AllProps) {
    this.loader(prevProps);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.unsubscribeFromUpdates) {
      this.unsubscribeFromUpdates();
      this.unsubscribeFromUpdates = undefined;
    }
  }

  render() {
    return <Header {...this.props} />;
  }
}

function mapStateToProps(state: State): StateProps {
  return {
    myId: getMyId(state),
    isLoggedIn: isLoggedIn(state),
    me: getMe(state),
    alwaysOpenBoardsMenu: state.ui.boardsMenu.alwaysOpenBoardsMenu,
    brandingColor: state.ui.header.brandingColor,
  };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    loadHeaderData: (id) => dispatch(loadHeader(id)),
    loadStaticHeaderData: (id) => dispatch(loadStaticHeader(id)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderContainer);
